/* SYMH "Stack it" add-on rail.

   ONE slider across EVERY book in the cart, not tabs for the first item.
   Boxes carry a cart signature and rebuild whenever the cart changes, so the
   drawer and the cart page cannot drift apart.

   MOUNTING - read this before you move it again.
   The rail is appended INSIDE the scrolling list of cart lines (last child of
   .cart-drawer-items / .cart-list-v2). v8.6 inserted it as a SIBLING of that
   list, which made it a direct child of the fixed, full-height flex column
   .cart-drawer. On desktop there was slack so nobody noticed. On a phone the
   drawer is the whole viewport: header + items(flex:1) + rail(287px) + footer,
   so the rail ate ~40% of the drawer, squeezed the cart lines to nothing and
   put a horizontal scroller in the middle of a vertical one. Inside the list it
   is just another row that scrolls away with the books.

   SOURCES - five, in priority order, per cart item (max 5 items):
     1 other covers of the same issue   badge ALT COVER
     2 other issues in the same series  badge #N
     3 same cover artist                badge COVER ART
     4 same writer                      badge WRITER
     5 same interior artist             badge ART

   See snippets/symh-stack-it.liquid for why the series TAG feed beats search,
   and assets/symh-stack-it.css for why this is styled unlike a cart line. */
(function(){
  var MAX_CARDS = 24;
  var MAX_ITEMS = 5;
  var PER_COVERS = 3, PER_RUN = 3, PER_COVER_ART = 2, PER_WRITER = 2, PER_ARTIST = 2;
  var PULL_TARGET = 4;
  var cache = {};

  function j(url){
    if (cache[url]) return cache[url];
    cache[url] = fetch(url).then(function(r){ return r.ok ? r.json() : null; })['catch'](function(){ return null; });
    return cache[url];
  }
  function feed(tagHandle){
    var url = '/collections/all/' + tagHandle + '?view=creatorfeed&sort_by=created-descending';
    if (cache[url]) return cache[url];
    cache[url] = fetch(url).then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(t){ try { return (JSON.parse(t.trim()).items) || []; } catch(e){ return []; } })['catch'](function(){ return []; });
    return cache[url];
  }
  function handleize(s){
    return String(s).normalize('NFKD').replace(/[̀-ͯ]/g,'').toLowerCase()
      .replace(/&/g,' and ').replace(/[^a-z0-9]+/g,'-').replace(/-{2,}/g,'-').replace(/^-|-$/g,'');
  }
  /* only de-slug real slugs - anything with a capital or a space is display-ready */
  function pretty(v){
    var s = String(v || '');
    if (!s || /[A-Z]/.test(s) || s.indexOf(' ') >= 0) return s;
    var toks = s.split('-').filter(Boolean), out = [], i = 0;
    while (i < toks.length){
      if (toks[i].length === 1 && /[a-z]/i.test(toks[i])){
        var jx = i;
        while (jx < toks.length && toks[jx].length === 1 && /[a-z]/i.test(toks[jx])) jx++;
        out.push(toks.slice(i, jx).map(function(c){ return c.toUpperCase() + '.'; }).join(''));
        i = jx; continue;
      }
      out.push(toks[i].charAt(0).toUpperCase() + toks[i].slice(1));
      i++;
    }
    return out.join(' ');
  }
  function esc(s){
    return String(s).replace(/[&<>"]/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];
    });
  }
  function issueOf(t){ var m = String(t).match(/#\s*(\d+)/); return m ? parseInt(m[1],10) : null; }
  function handleOf(u){ return String(u).split('?')[0].split('/').pop(); }
  function shortName(t, series){
    var s = String(t);
    if (series) s = s.replace(new RegExp('^' + series.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + '\\s*', 'i'), '');
    return s.replace(/^#\s*\d+\s*/,'').trim() || String(t);
  }

  /* the three tag vocabularies all survive this: title:ghost-pepper,
     titleGhost Pepper, writer-Al Ewing */
  function pick(raw, prefix){
    if (String(raw).toLowerCase().indexOf(prefix) !== 0) return null;
    if (raw.length <= prefix.length) return null;
    var v = raw.slice(prefix.length);
    if (v[0] === ':' || v[0] === '-') v = v.slice(1);
    v = v.trim();
    return v ? { value: pretty(v), handle: handleize(raw) } : null;
  }
  function tagsOf(product){
    var out = {series:null, cover:null, writer:null, artist:null};
    (product.tags || []).forEach(function(raw){
      var low = String(raw).toLowerCase(), v;
      if (!out.series && (v = pick(raw,'title'))) out.series = v;
      if (!out.series && low.indexOf('series-group') !== 0 && (v = pick(raw,'series'))) out.series = v;
      if (!out.cover  && (v = pick(raw,'cover-artist'))) out.cover  = v;
      if (!out.writer && (v = pick(raw,'writer'))) out.writer = v;
      if (!out.artist && (v = pick(raw,'artist'))) out.artist = v;
    });
    return out;
  }

  function collect(cartItems){
    var items = cartItems.slice(0, MAX_ITEMS);
    var inCart = {};
    cartItems.forEach(function(ci){ inCart[ci.handle] = 1; });
    return Promise.all(items.map(function(ci){
      return j('/products/' + ci.handle + '.js').then(function(p){
        if (!p) return null;
        var t = tagsOf(p);
        return Promise.all([
          t.series ? feed(t.series.handle) : Promise.resolve([]),
          t.cover  ? feed(t.cover.handle)  : Promise.resolve([]),
          t.writer ? feed(t.writer.handle) : Promise.resolve([]),
          t.artist ? feed(t.artist.handle) : Promise.resolve([])
        ]).then(function(res){
          return {tags:t, iss:issueOf(p.title), sib:res[0]||[],
                  cr:res[1]||[], wr:res[2]||[], ar:res[3]||[]};
        });
      });
    })).then(function(all){
      var picks = [], seenH = {};
      var reasons = {covers:0, run:0, coverart:0, writer:0, artist:0};
      function push(x, kind, badge, series){
        var h = handleOf(x.u);
        if (!x.avail || inCart[h] || seenH[h]) return false;
        seenH[h] = 1;
        picks.push({u:x.u, img:x.img, price:x.price, badge:badge,
                    label:shortName(x.t, series), kind:kind});
        reasons[kind]++;
        return true;
      }
      /* pass 1 - other covers of the exact issue in the cart */
      all.forEach(function(g){
        if (!g) return; var n = 0;
        g.sib.forEach(function(x){
          if (n >= PER_COVERS) return;
          if (g.iss !== null && issueOf(x.t) === g.iss){
            if (push(x, 'covers', 'ALT COVER', g.tags.series && g.tags.series.value)) n++;
          }
        });
      });
      /* pass 2 - the rest of the run */
      all.forEach(function(g){
        if (!g) return; var n = 0, seenIss = {};
        g.sib.forEach(function(x){
          if (n >= PER_RUN) return;
          var iss = issueOf(x.t);
          if (iss === null || iss === g.iss || seenIss[iss]) return;
          seenIss[iss] = 1;
          if (push(x, 'run', '#' + iss, g.tags.series && g.tags.series.value)) n++;
        });
      });
      /* passes 3-5 - the people. Cover art first: it is the most visually
         obvious match, so it earns the scarce early slots. */
      [['cr','cover','coverart','COVER ART',PER_COVER_ART],
       ['wr','writer','writer','WRITER',PER_WRITER],
       ['ar','artist','artist','ART',PER_ARTIST]].forEach(function(spec){
        all.forEach(function(g){
          if (!g || !g.tags[spec[1]]) return; var n = 0;
          (g[spec[0]] || []).forEach(function(x){
            if (n >= spec[4]) return;
            if (push(x, spec[2], spec[3], null)) n++;
          });
        });
      });
      return {picks:picks.slice(0, MAX_CARDS), reasons:reasons, groups:all.filter(Boolean)};
    });
  }

  function card(b, idx){
    return '<a class="sk__bk" href="' + esc(b.u) + '" style="animation-delay:' + Math.min(idx*35,420) + 'ms">'
      + '<div class="sk__img">'
      + (b.img ? '<img loading="lazy" src="' + esc(b.img) + '" alt="">' : '')
      + '<span class="sk__plus">+</span>'
      + (b.badge ? '<span class="sk__badge">' + esc(b.badge) + '</span>' : '')
      + '</div><div class="sk__name">' + esc(b.label) + '</div>'
      + '<div class="sk__price">' + esc(b.price || '') + '</div></a>';
  }

  function headline(r, groups){
    var uniq = [];
    groups.forEach(function(g){
      var v = g.tags.series && g.tags.series.value;
      if (v && uniq.indexOf(v) < 0) uniq.push(v);
    });
    var who = uniq.length === 1 ? uniq[0]
            : uniq.length === 2 ? uniq[0] + ' and ' + uniq[1]
            : 'what you have';
    if (r.covers && r.run) return 'More covers and back issues for <span class="hl">' + esc(who) + '</span>.';
    if (r.covers) return 'More covers for <span class="hl">' + esc(who) + '</span>.';
    if (r.run) return 'More issues of <span class="hl">' + esc(who) + '</span> still in stock.';
    return 'More from the creators behind <span class="hl">' + esc(who) + '</span>.';
  }

  function build(res, host, sig){
    if (!res.picks.length) return;
    var el = document.createElement('div');
    el.className = 'sk';
    el.setAttribute('data-sk-sig', sig);
    el.innerHTML = '<div class="sk__head">'
      + '<div class="sk__eyebrow"><span class="dot"></span>Add ons'
      +   '<span class="not">- not in your cart</span></div>'
      + '<div class="sk__title">' + headline(res.reasons, res.groups) + '</div></div>'
      + '<div class="sk__wrap">'
      +   '<button type="button" class="sk__arw sk__arw--l" aria-label="Scroll left">&#8249;</button>'
      +   '<div class="sk__rail">' + res.picks.map(card).join('') + '</div>'
      +   '<button type="button" class="sk__arw sk__arw--r" aria-label="Scroll right">&#8250;</button>'
      + '</div>'
      + '<div class="sk__foot">' + res.picks.length + ' add ons for the books above. Tap any cover to open it.</div>';
    var rail = el.querySelector('.sk__rail');
    el.querySelector('.sk__arw--l').addEventListener('click', function(){ rail.scrollBy({left:-282, behavior:'smooth'}); });
    el.querySelector('.sk__arw--r').addEventListener('click', function(){ rail.scrollBy({left:282, behavior:'smooth'}); });
    host.appendChild(el);
  }

  function sigOf(c){
    return (c.items || []).map(function(i){ return i.handle + 'x' + i.quantity; }).join('|');
  }

  function wipe(h){
    var ex = h.querySelectorAll(':scope > .sk');
    Array.prototype.forEach.call(ex, function(e){ if (e.parentNode) e.parentNode.removeChild(e); });
    return ex.length;
  }

  /* mountCart is re-entrant by design: the click listener and the fetch hook can
     both fire for one add-to-cart. v8.7 let two runs overlap - both awaited
     /cart.js, both saw no box yet, both appended, and the drawer ended up with
     two identical rails on the second add. The busy latch serialises them;
     dirty replays the last one so a cart change during a build is not
     swallowed; wipe() immediately before append is the belt to that
     suspenders. */
  var busy = false, dirty = false;
  function mountCart(){
    /* hosts, not anchors: the rail goes INSIDE the scrolling list. See header. */
    var hosts = [
      document.querySelector('form.cart-form-v2 > .cart-list-v2'),
      document.querySelector('#cart-drawer .cart-drawer-items')
    ].filter(Boolean);
    if (!hosts.length) return;
    if (busy){ dirty = true; return; }
    busy = true;
    function done(){
      busy = false;
      if (dirty){ dirty = false; setTimeout(mountCart, 250); }
    }
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var sig = sigOf(c);
      var todo = hosts.filter(function(h){
        var ex = h.querySelectorAll(':scope > .sk');
        if (ex.length === 1 && ex[0].getAttribute('data-sk-sig') === sig) return false;
        wipe(h);
        return true;
      });
      if (!todo.length || !c.items || !c.items.length){ done(); return; }
      return collect(c.items).then(function(res){
        todo.forEach(function(h){ wipe(h); build(res, h, sig); });
        done();
      });
    })['catch'](done);
  }

  /* mountPull used to draw the "Reserve N more and the whole list drops 15%"
     strip at the top of /pages/pull-list. Mission Control's dock shows the
     same progress, so the strip was a duplicate (Rich, 2026-09-30) — the
     page now carries the customer's OPEN ORDERS there instead. Cart-side
     stacking above is untouched. */
  function mountPull(){ return; }
  function init(){ try { mountCart(); mountPull(); } catch(e){} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* The cart changes without a reload: drawer opens, quantity steppers, removes.
     Re-check after each so the drawer and the cart page never disagree. */
  document.addEventListener('click', function(){ setTimeout(init, 700); }, true);
  var _f = window.fetch;
  window.fetch = function(){
    var u = arguments[0];
    var p = _f.apply(this, arguments);
    try {
      if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)){
        p.then(function(){ setTimeout(init, 400); })['catch'](function(){});
      }
    } catch(e){}
    return p;
  };
})();
